import script from "./GrHambuger.vue?vue&type=script&setup=true&lang=js"
export * from "./GrHambuger.vue?vue&type=script&setup=true&lang=js"

import "./GrHambuger.vue?vue&type=style&index=0&id=12054e41&lang=scss"

const __exports__ = script;

export default __exports__